import {LocaleConfig} from 'platform/locale';

import {pipe} from 'ramda';

import {Nullish} from 'shared/web';

import {DECIMAL_DOT} from '../../../constants/numberConstants';

export const getNumberFromString = (
  numberLocale: LocaleConfig['number'],
  value: string | Nullish
) =>
  pipe(
    (str: string) => str.split(numberLocale.thousandsSeparator).join(''),
    (str: string) => str.replace(numberLocale.decimalSeparator, DECIMAL_DOT),
    Number
  )(value ?? '');
